import {Component, OnInit, Inject, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents, IrbModelsEvents} from '@irb-common/events';
import { ImportSecurityCategoryOverwriteGridLayoutService } from './import-security-category-overwrite.grid-layout.service';
import { SecurityMasterService } from '../security-master/security-master.service';
import { IAlertDialogData } from '@irb/app.model';

@Component({ standalone: false,
  selector: 'irb-import-security-category-overwrite-dialog',
  templateUrl: './import-security-category-overwrite-dialog.component.html',
  styleUrls: ['./import-security-category-overwrite-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportSecurityCategoryOverwriteDialogComponent implements OnInit, OnDestroy {
    grid: any;
    gridOptions: any;
    isFinish: boolean = false;
    updateStatusCount = 0;
    progressTimer: any;
    isUiTest = false;
    frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportSecurityCategoryOverwriteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportSecurityCategoryOverwriteGridLayoutService,
    public securityMasterService:SecurityMasterService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
      if (this.data) {
          if (this.data.unRecognized && this.data.unRecognized.count === 0 && this.data.NonInventoried && this.data.NonInventoried.count === 0) {
              this.isFinish = true;
          }
      }
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    if (this.data.unRecognized.count === 0 && this.data.NonInventoried.count === 0) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      this.securityMasterService.addNewSecurityProfilesAsync(this.data.Inventoried.data).subscribe((response: any) => {
          //this.updateNewSecurityProfilesFinish(response);
          this.updateStatusCount = 0;
          if (this.progressTimer)  clearTimeout(this.progressTimer);
          this.updateStatusCount = 0;
          if (response.responseUtilityMap)
              this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
      }, () => {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    } else {
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, this.data);
        this.close();
    }

  }

  refreshRequired(){
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: 'Refresh Required',
        dProceedBtnLabel: 'Refresh',
        msg: "You are attempting to create or update securities that was just modified by someone else. To see the updated securities, you need to refresh the page.",
        onProceed: () => {this.as.fireEvent(IrbAppEvents.GRID_REFRESH);}
    } as IAlertDialogData);
  }

    updateNewSecurityProfilesFinish(response: any) {
        if(response.responseStatus=== "SUCCESS") {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'success',
                summary: "Import Security Category",
                detail: this.data.oerwriteData.length + " security(ies) updated."
            });
            this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        } else if (response.responseStatus === "STALEDATAEXCEPTION") {
            this.refreshRequired();
        } else{
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: "Import Security Category",
                detail: " An error occurred processing your request."
            });
        }
    }

    actionStatusCheckIntervalStart(statusId: any) {
        this.securityMasterService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
            if (statusResponse.responseStatus === "SUCCESS") {

                let reqStatus = 'FAILED';
                if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
                    reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
                }

                if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
                    if (this.isUiTest)
                        timeout = 0;
                    this.updateStatusCount++;
                    this.progressTimer = setTimeout(() => {
                        this.actionStatusCheckIntervalStart(statusId);
                    }, timeout);
                }

                if (reqStatus === 'COMPLETED') {
                    const responseData = JSON.parse(statusResponse.responseData);
                    this.updateNewSecurityProfilesFinish(responseData);
                    this.close();
                    if (this.progressTimer)  clearTimeout(this.progressTimer);
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                }

                if (reqStatus === 'STALEDATAEXCEPTION') {
                    this.close();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    if (this.progressTimer)  clearTimeout(this.progressTimer);
                    this.refreshRequired();
                }

                if (reqStatus === 'FAILED') {
                    this.actionStatusCheckFailed();
                }
            } else {
                this.actionStatusCheckFailed();
            }
        }, () => {
            this.close();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            if (this.progressTimer)  clearTimeout(this.progressTimer);
        });
    }

    actionStatusCheckFailed() {
        this.close();
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if (this.progressTimer)  clearTimeout(this.progressTimer);
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: "Import Security Category",
            detail: " An error occurred processing your request."
        });
    }

    ngOnDestroy() {
      if (this.progressTimer)  clearTimeout(this.progressTimer);
    }
}
